var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.84 7.61328L17.2666 1.03996C16.6 0.373291 15.6933 0 14.7466 0H8.89331C4.47998 0 0.893311 3.58667 0.893311 8V16C0.893311 20.4133 4.47998 24 8.89331 24H16.8933C21.3066 24 24.8933 20.4133 24.8933 16V10.1466C24.8933 9.19998 24.52 8.29329 23.8533 7.62663L23.84 7.61328ZM16.5466 4.09334L20.8 8.34668H18.68C17.5066 8.34668 16.5466 7.45335 16.5466 6.34668V4.09334ZM16.88 21.32H8.87996C5.9333 21.32 3.54663 18.9333 3.54663 15.9867V7.98665C3.54663 5.03999 5.9333 2.65332 8.87996 2.65332H13.8666V6.34668C13.8666 8.92001 16.0266 11.0133 18.6666 11.0133H22.2V15.9867C22.2 18.9333 19.8133 21.32 16.8666 21.32H16.88Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.b6cb5d7ef81a0c48cd534b2a60fac12c.svg";
export { ForwardRef as ReactComponent };